import { getPullRequestNumberAsString } from "./getPullRequestNumberAsString";

export const isPullRequest = (ref?: string): boolean => {
  return !isNaN(parseFloat(getPullRequestNumberAsString(ref)));
};
